module.exports = __webpack_public_path__ + "static/x100v-cardinal-3e3f788c2a53f7ab2d51564165a4fa69.jpg";